<template>
  <div class="gmf-item-color-pill">
    <ColorPillBase :colors="colors" />
  </div>
</template>
<style>
.gmf-item-color-pill.gmf-active {
  background-color: unset;
  border: var(--gmf-p-2) solid var(--gmf-col-gray);
}

.gmf-item-color-pill {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  padding: calc(var(--gmf-p-1) + 1px);
  border: var(--gmf-p-2) solid transparent;
}

.gmf-item-color-pill .gmf-color-pill {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
}
</style>
<script>
import ColorPillBase from '../AvatarConfigurator/colors/ColorPillBase';

export default {
  components: {
    ColorPillBase,
  },
  props: {
    colors: {
      Type: [Array, Object, String], // Set ColorPillBase for usage.
    },
  },
};
</script>